import { render, staticRenderFns } from "./CalendarPlaceholder.vue?vue&type=template&id=8c40440e&"
import script from "./CalendarPlaceholder.vue?vue&type=script&lang=js&"
export * from "./CalendarPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports